export { SamOnboardingImage } from './OnboardingImage';
